import registerReduxModal from 'components/common/hoc/registerReduxModal'
import { SUCCESSFUL_SUBMIT_MODAL } from './constants'
import SuccessfulSubmitModal from './SuccessfulSubmitModal'

export default registerReduxModal({ name: SUCCESSFUL_SUBMIT_MODAL })(SuccessfulSubmitModal)
